import {
  addSlidesTabIndex
} from '@gravity-global/helpers/swiper/add-slides-tab-index';
import Gravity from 'gravityglobal-parent/assets/js/global-functions';

const sliderLogoCarousel = () => {
  document
    .querySelectorAll('.gg-logo-carousel .wp-block-statik-slider > .swiper')
    /* eslint-disable */
    .forEach((clientLogosCarousel) => {
      clientLogosCarousel.swiper.params.watchSlidesProgress = true;
      clientLogosCarousel.swiper.params.spaceBetween = 0;
      clientLogosCarousel.swiper.params.grabCursor = true;
      clientLogosCarousel.swiper.params.observer = true;
      clientLogosCarousel.swiper.params.observerParents = true;
      clientLogosCarousel.swiper.params.breakpoints = {
        /* eslint-enable */
        0: {
          slidesPerView: 2,
        },
        600: {
          slidesPerView: 3,
        },
        800: {
          slidesPerView: 4,
        },
        1025: {
          slidesPerView: 5,
        },
      };
      addSlidesTabIndex(clientLogosCarousel.swiper);

      clientLogosCarousel.swiper.on('slideChange', () => {
        addSlidesTabIndex(clientLogosCarousel.swiper);
      });

      clientLogosCarousel.swiper.update();
    });
};

Gravity.ready(sliderLogoCarousel);
